import React, { Component } from "react";
import BasicCommonFileSettings from "./BasicCommonFileSettings";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Trans, withTranslation } from "react-i18next";

const styles = (theme) => ({
  container: {
    margin: "25px 0",
    display: "flex",
    flexDirection: "column",
  },
  helperText: {
    marginTop: 0,
    marginBottom: 10,
  },
});

export class BasicDriveSettings extends Component {
  state = {
    driveIncludeMyDrive: false,
    authOnDomain: false,
    userToImpersonate: "",
    childProperties: {
      presentationProperties: {},
      readerProperties: {},
      reindexerProperties: {},
      sourceProperties: {},
      spiderProperties: {},
    },
  };

  componentDidMount() {
    this.parseEditKs();
    this.settingsUpdated();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.settingsUpdated();
    }
    if (this.props.editKs !== prevProps.editKs) {
      this.parseEditKs();
    }
  }

  parseEditKs = () => {
    if (this.props.editKs && Object.keys(this.props.editKs).length > 0) {
      this.setState({
        driveIncludeMyDrive: !!this.props.editKs.properties.spiderProperties
          .includeMyDrive,
      });
      this.setState({
        authOnDomain: !!this.props.editKs.properties.spiderProperties
          .authDomain,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Typography gutterBottom variant="h5">
          <Trans i18nKey="create_ks_google_drive_settings" />
        </Typography>
        <FormGroup>
          <>
            <FormControlLabel
              disabled={this.state.authOnDomain}
              control={
                <Checkbox
                  checked={this.state.driveIncludeMyDrive}
                  id="ks-drive-include-my-drive"
                  onChange={(e) =>
                    this.setState({ driveIncludeMyDrive: e.target.checked })
                  }
                  value="driveIncludeMyDrive"
                />
              }
              label={this.props.t("create_ks_google_drive_include_my_drive")}
            />
            {this.state.authOnDomain && (
              <FormHelperText className={classes.helperText}>
                <Trans i18nKey="create_ks_google_drive_include_my_drive_info" />
              </FormHelperText>
            )}
          </>
        </FormGroup>
        {/* <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.authOnDomain}
                onChange={(e) =>
                  this.setState({ authOnDomain: e.target.checked })
                }
                value="authOnDomain"
              />
            }
            label={this.props.t("create_ks_google_drive_service_account")}
          />
          <FormHelperText className={classes.helperText}>
            <Trans i18nKey="create_ks_google_drive_service_account_info" />
          </FormHelperText>
        </FormGroup>
        <Collapse in={this.state.authOnDomain}>
          <TextField
            style={{ width: "50%" }}
            id="google-drive-impersonate-user"
            label={this.props.t("create_ks_google_drive_impersonate_user")}
            onChange={(e) =>
              this.setState({ userToImpersonate: e.target.value })
            }
            value={this.state.userToImpersonate}
            helperText={this.props.t(
              "create_ks_google_drive_impersonate_user_helper_text"
            )}
          />
        </Collapse> */}
      </div>
    );
  }

  settingsUpdated = () => {
    this.props.setSpiderProperties({
      includeMyDrive: this.state.authOnDomain
        ? false
        : this.state.driveIncludeMyDrive,
      authOnDomain: this.state.authOnDomain,
      impersonateUser: this.state.userToImpersonate,
    });
  };
}

export default withStyles(styles)(withTranslation()(BasicDriveSettings));
